/*
  Forma arkası isimli numaralı taraftar posteri stüdyosu (Teeinblue yerine kendi stüdyomuz).
  Her ürün bir forma tasarımı (etiket fm-tasarim-<kimlik>). Forma kodla vektör olarak çizilir (yaka, omuz/kol dikişleri,
  gövde deseni: düz / çubuklu / parçalı, alt çubuklar, şeritler); üstüne tek bir gerçek kumaş dokusu bindirilir
  (gölge: multiply, ışık: screen). İsim ve numara Big Shoulders Display 900. Önizlemede doku temadan (900×1260),
  baskıda R2'den (3937×5512 = 50×70 cm @200 dpi). Sepete eklerken poster tam çözünürlükte JPEG olarak çizilir,
  sunucu 50×70 PDF yapar (/forma/baski). Ortak görünüm fso-muzik-poster.css'ten (fso-mp-* sınıfları).
*/
(function () {
  'use strict';
  if (window.FsoForma) return;

  var BW = 1000, BH = 1400; // ölçüler bu birimlerde (poster 5:7)
  var BASKI = [[3937, 5512], [3200, 4480], [2600, 3640]]; // tuval açılamazsa (iOS ~16 MP sınırı) küçült
  var YAZI = '"Big Shoulders Display", "Oswald", "Arial Narrow", sans-serif';
  var AD = { x: 500, y: 362, boy: 122, azamiEn: 660, ornek: 'İSMİNİZ' };
  var NUMARA = { x: 500, y: 968, boy: 610, azamiEn: 690, ornek: '10' };
  // Tasarımlar. govde: { tur: 'duz', renk } | { tur: 'cubuk', renkler: [a, b], adet } | { tur: 'parcali', sol, sag }
  // kol: kollar (kolSag verilirse sağ kol ayrı), yaka: yaka bandı, arka: omuzların üstündeki zemin,
  // ekler: { tur: 'alt-cubuk', renk, y, adet } (alt kısımda dikey çubuklar) | { tur: 'serit', renk, y, h } (yatay şerit)
  //        | { tur: 'kenar', renk, w, bosluk } (iki yanda ince dikey şeritler)
  // yazi: isim/numara dolgu, kontur, gölge
  var KIRMIZI = '#A3171F', SARI = '#F2A900', LACI = '#0B1F4D', SARI2 = '#F7C600', SIYAH = '#141414', BEYAZ = '#F3F3F1';
  var TASARIM = {
    'sari-kirmizi-parcali': { ad: 'Sarı Kırmızı Parçalı', govde: { tur: 'parcali', sol: KIRMIZI, sag: SARI }, kol: SARI, kolSag: KIRMIZI, yaka: KIRMIZI,
      yazi: { dolgu: '#FFFFFF', kontur: '#5E0B10', golge: '#4A080C' } },
    'sari-kirmizi-cubuklu': { ad: 'Sarı Kırmızı Çubuklu', govde: { tur: 'cubuk', renkler: [KIRMIZI, SARI], adet: 5 }, kol: KIRMIZI, yaka: KIRMIZI,
      yazi: { dolgu: '#FFFFFF', kontur: '#6B0E14', golge: '#4A080C' } },
    'sari-kirmizi': { ad: 'Sarı Kırmızı', govde: { tur: 'duz', renk: KIRMIZI }, kol: SARI, yaka: SARI,
      ekler: [{ tur: 'serit', renk: SARI, y: 1235, h: 58 }, { tur: 'serit', renk: SARI, y: 1318, h: 18 }],
      yazi: { dolgu: SARI, kontur: '#5A0A0F', golge: '#3E0609' } },
    'sari-lacivert-cubuklu': { ad: 'Sarı Lacivert Çubuklu', govde: { tur: 'cubuk', renkler: [LACI, SARI2], adet: 7 }, kol: LACI, yaka: LACI,
      yazi: { dolgu: '#FFFFFF', kontur: LACI, golge: '#071433' } },
    'sari-lacivert': { ad: 'Sarı Lacivert', govde: { tur: 'duz', renk: SARI2 }, kol: LACI, yaka: LACI,
      ekler: [{ tur: 'alt-cubuk', renk: LACI, y: 1090, adet: 9 }],
      yazi: { dolgu: LACI, kontur: LACI, golge: 'rgba(7,20,51,0.3)' } },
    'siyah-beyaz-cubuklu': { ad: 'Siyah Beyaz Çubuklu', govde: { tur: 'cubuk', renkler: [SIYAH, BEYAZ], adet: 7 }, kol: SIYAH, yaka: SIYAH,
      yazi: { dolgu: '#FFFFFF', kontur: '#111111', golge: '#000000' } },
    'beyaz-siyah': { ad: 'Beyaz Siyah', arka: '#2B2B2B', govde: { tur: 'duz', renk: BEYAZ }, kol: SIYAH, yaka: SIYAH,
      ekler: [{ tur: 'alt-cubuk', renk: SIYAH, y: 1090, adet: 9 }],
      yazi: { dolgu: '#111111', kontur: '#111111', golge: 'rgba(0,0,0,0.18)' } },
    'bordo-mavi': { ad: 'Bordo Mavi', govde: { tur: 'duz', renk: '#6E1A2E' }, kol: '#86BFE6', yaka: '#86BFE6',
      ekler: [{ tur: 'alt-cubuk', renk: '#86BFE6', y: 1090, adet: 9 }],
      yazi: { dolgu: '#8CC4EA', kontur: '#FFFFFF', golge: '#3A0D18' } },
    'kirmizi-beyaz': { ad: 'Kırmızı Beyaz', govde: { tur: 'duz', renk: '#D21F26' }, kol: '#D21F26', yaka: '#FFFFFF',
      ekler: [{ tur: 'serit', renk: '#FFFFFF', y: 1196, h: 16 }, { tur: 'serit', renk: '#FFFFFF', y: 1230, h: 16 }],
      yazi: { dolgu: '#FFFFFF', kontur: '#8E0F14', golge: '#6A0A0E' } },
    'yesil-beyaz-cubuklu': { ad: 'Yeşil Beyaz Çubuklu', govde: { tur: 'cubuk', renkler: ['#0E7A3B', BEYAZ], adet: 5 }, kol: '#0E7A3B', yaka: '#0E7A3B',
      yazi: { dolgu: '#FFFFFF', kontur: '#0A4F27', golge: '#06361A' } },
    'mavi-siyah-cubuklu': { ad: 'Mavi Siyah Çubuklu', govde: { tur: 'cubuk', renkler: [SIYAH, '#1446A0'], adet: 7 }, kol: SIYAH, yaka: SIYAH,
      yazi: { dolgu: '#FFFFFF', kontur: '#0A0A0A', golge: '#000000' } },
    'lacivert': { ad: 'Lacivert', govde: { tur: 'duz', renk: '#0E1A3A' }, kol: '#0E1A3A', yaka: '#C9A55A',
      ekler: [{ tur: 'kenar', renk: '#C9A55A', w: 14, bosluk: 30 }],
      yazi: { dolgu: '#D4B06A', kontur: '#05091A', golge: '#03050F' } },
  };
  var RENKLER = [[/beyaz|white/i, 'beyaz'], [/siyah|black/i, 'siyah'], [/ceviz|walnut/i, 'ceviz'], [/ah[sş]ap|naturel|wood|me[sş]e/i, 'ahsap'], [/alt[ıi]n|gold/i, 'altin']];
  var METIN = {
    adEt: 'Forma arkasındaki isim',
    adOrnek: 'İSMİNİZ',
    numaraEt: 'Sırt numarası',
    numaraOrnek: '10',
    yardim: 'İsim en fazla 16 harf; numara 0–9999 (doğum yılı da olur). Uzun isimler kendiliğinden sığdırılır.',
    digerleri: 'Diğer forma renkleri',
    once: 'Önce forma arkasındaki ismi ve numarayı yaz.',
    baskiHazirlaniyor: 'Baskı dosyan hazırlanıyor…',
    yukleniyor: 'Yükleniyor',
    baskiHata: 'Baskı dosyası gönderilemedi, lütfen tekrar dene.',
    gorunum: 'Görünüm', gorunumPoster: 'Posterin', gorunumGaleri: 'Ürün fotoğrafları',
    yukari: 'Posterin yukarıda, görmek için dokun',
  };
  var SIMGE = {
    yukari: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 19V5"/><path d="M5 12l7-7 7 7"/></svg>',
  };

  function el(etiket, sinif, html) { var e = document.createElement(etiket); if (sinif) e.className = sinif; if (html != null) e.innerHTML = html; return e; }
  function tuval(w, h) { var c = document.createElement('canvas'); c.width = Math.max(1, Math.round(w)); c.height = Math.max(1, Math.round(h)); return c; }
  function tuvalBlob(c, q) { return new Promise(function (tamam) { c.toBlob(tamam, 'image/jpeg', q); }); }
  function resimYukle(src, cors) {
    return new Promise(function (tamam, red) {
      var img = new Image();
      if (cors) img.crossOrigin = 'anonymous';
      img.onload = function () { tamam(img); };
      img.onerror = function () { red(new Error('görsel açılamadı: ' + src)); };
      img.src = src;
    });
  }
  var yaziHazir = null;
  function yaziYukle() {
    if (!yaziHazir) {
      yaziHazir = document.fonts && document.fonts.load
        ? document.fonts.load('900 100px "Big Shoulders Display"', 'İŞĞÜÖÇ0123456789').catch(function () {})
        : Promise.resolve();
    }
    return yaziHazir;
  }
  function buyuk(s) { return String(s || '').toLocaleUpperCase('tr-TR'); }

  /* ---------- Forma (vektör) ----------
     Arka görünüm, yakından: yaka üstte ortada, omuz çizgileri kenarlara iner, kollar üst köşelerde (kenarlardan taşar),
     gövde aşağıya kadar uzanır (etek kadraj dışında). Ölçüler 1000×1400 biriminde. */
  var YAKA = { sol: [380, 52], sag: [620, 52], kontrol: [500, 98] };
  var OMUZ = { sol: [150, 118], sag: [850, 118], kenarY: 160 };
  var KOLTUK = { y: 470, kontrolX: 150, kontrolY: 330 };
  function govdeYolu(k) {
    var p = new Path2D();
    p.moveTo(YAKA.sol[0] * k, YAKA.sol[1] * k);
    p.lineTo(OMUZ.sol[0] * k, OMUZ.sol[1] * k);
    p.quadraticCurveTo(KOLTUK.kontrolX * k, KOLTUK.kontrolY * k, 0, KOLTUK.y * k);
    p.lineTo(0, BH * k); p.lineTo(BW * k, BH * k); p.lineTo(BW * k, KOLTUK.y * k);
    p.quadraticCurveTo((BW - KOLTUK.kontrolX) * k, KOLTUK.kontrolY * k, OMUZ.sag[0] * k, OMUZ.sag[1] * k);
    p.lineTo(YAKA.sag[0] * k, YAKA.sag[1] * k);
    p.quadraticCurveTo(YAKA.kontrol[0] * k, YAKA.kontrol[1] * k, YAKA.sol[0] * k, YAKA.sol[1] * k);
    p.closePath();
    return p;
  }
  function kolYolu(k, sag) {
    var x = function (v) { return (sag ? BW - v : v) * k; };
    var p = new Path2D();
    p.moveTo(x(0), OMUZ.kenarY * k);
    p.lineTo(x(OMUZ.sol[0]), OMUZ.sol[1] * k);
    p.quadraticCurveTo(x(KOLTUK.kontrolX), KOLTUK.kontrolY * k, x(0), KOLTUK.y * k);
    p.closePath();
    return p;
  }
  function desenCiz(ctx, k, desen) {
    if (!desen) return;
    if (desen.tur === 'cubuk') {
      var n = desen.adet || 7, w = BW / n;
      for (var i = 0; i < n; i++) { ctx.fillStyle = desen.renkler[i % 2]; ctx.fillRect(i * w * k - 0.5, 0, w * k + 1, BH * k); }
    } else if (desen.tur === 'parcali') {
      ctx.fillStyle = desen.sol; ctx.fillRect(0, 0, BW / 2 * k + 0.5, BH * k);
      ctx.fillStyle = desen.sag; ctx.fillRect(BW / 2 * k, 0, BW / 2 * k, BH * k);
    } else {
      ctx.fillStyle = desen.renk; ctx.fillRect(0, 0, BW * k, BH * k);
    }
  }
  function ekCiz(ctx, k, e) {
    ctx.fillStyle = e.renk;
    if (e.tur === 'alt-cubuk') {
      var n = e.adet || 9, w = BW / n;
      for (var i = 1; i < n; i += 2) ctx.fillRect(i * w * k, e.y * k, w * k, (BH - e.y) * k);
    } else if (e.tur === 'serit') {
      ctx.fillRect(0, e.y * k, BW * k, e.h * k);
    } else if (e.tur === 'kenar') {
      [e.bosluk, BW - e.bosluk - e.w].forEach(function (x) { ctx.fillRect(x * k, 0, e.w * k, BH * k); });
    }
  }
  function formaCiz(ctx, k, t) {
    ctx.fillStyle = t.arka || '#171717';
    ctx.fillRect(0, 0, BW * k, BH * k);
    // Gövde (desen + ekler) gövde yoluna kırpılır
    var govde = govdeYolu(k);
    ctx.save(); ctx.clip(govde);
    desenCiz(ctx, k, t.govde);
    (t.ekler || []).forEach(function (e) { ekCiz(ctx, k, e); });
    ctx.restore();
    // Kollar
    [[false, t.kol], [true, t.kolSag || t.kol]].forEach(function (a) {
      ctx.fillStyle = a[1]; ctx.fill(kolYolu(k, a[0]));
    });
    // Dikişler (hafif gölge çizgileri) ve yaka bandı
    ctx.save();
    ctx.strokeStyle = 'rgba(0,0,0,0.18)'; ctx.lineWidth = 3 * k; ctx.lineCap = 'round';
    [false, true].forEach(function (sag) {
      var x = function (v) { return (sag ? BW - v : v) * k; };
      ctx.beginPath(); ctx.moveTo(x(OMUZ.sol[0]), OMUZ.sol[1] * k); ctx.quadraticCurveTo(x(KOLTUK.kontrolX), KOLTUK.kontrolY * k, x(0), KOLTUK.y * k); ctx.stroke();
      ctx.beginPath(); ctx.moveTo(x(YAKA.sol[0]), YAKA.sol[1] * k); ctx.lineTo(x(0), OMUZ.kenarY * k); ctx.stroke();
    });
    ctx.strokeStyle = t.yaka; ctx.lineWidth = 26 * k; ctx.lineCap = 'butt';
    ctx.beginPath(); ctx.moveTo(YAKA.sol[0] * k, YAKA.sol[1] * k); ctx.quadraticCurveTo(YAKA.kontrol[0] * k, YAKA.kontrol[1] * k, YAKA.sag[0] * k, YAKA.sag[1] * k); ctx.stroke();
    ctx.strokeStyle = 'rgba(0,0,0,0.22)'; ctx.lineWidth = 2.5 * k;
    ctx.beginPath(); ctx.moveTo(YAKA.sol[0] * k, (YAKA.sol[1] + 13) * k); ctx.quadraticCurveTo(YAKA.kontrol[0] * k, (YAKA.kontrol[1] + 13) * k, YAKA.sag[0] * k, (YAKA.sag[1] + 13) * k); ctx.stroke();
    ctx.restore();
  }

  /* ---------- Yazı ---------- */
  function metinCiz(ctx, metin, kutu, k, stil) {
    var boy = kutu.boy * k;
    ctx.font = '900 ' + boy + 'px ' + YAZI;
    var en = ctx.measureText(metin).width;
    if (en > kutu.azamiEn * k) { boy = boy * (kutu.azamiEn * k) / en; ctx.font = '900 ' + boy + 'px ' + YAZI; }
    var x = kutu.x * k, y = kutu.y * k;
    var kalin = boy * (kutu === NUMARA ? 0.045 : 0.07), kay = boy * (kutu === NUMARA ? 0.028 : 0.045);
    ctx.textAlign = 'center';
    ctx.textBaseline = 'alphabetic';
    ctx.lineJoin = 'round';
    // Kontur yalnız dolgudan farklı renkteyse (aynı renkte harfler kalınlaşıp okunmaz oluyordu)
    var kontur = stil.kontur && stil.kontur !== stil.dolgu;
    ctx.fillStyle = stil.golge; ctx.strokeStyle = stil.golge; ctx.lineWidth = kontur ? kalin * 2 : 0.001;
    if (kontur) ctx.strokeText(metin, x + kay, y + kay);
    ctx.fillText(metin, x + kay * (kontur ? 1 : 0.6), y + kay * (kontur ? 1 : 0.6));
    if (kontur) { ctx.strokeStyle = stil.kontur; ctx.lineWidth = kalin * 2; ctx.strokeText(metin, x, y); }
    ctx.fillStyle = stil.dolgu;
    ctx.fillText(metin, x, y);
  }

  /* ---------- Poster ----------
     d: { tasarim, ad, numara, golge (img | null), isik (img | null), ornek (bool: boş alanlarda örnek yazı) } */
  function posterCiz(cv, d) {
    var ctx = cv.getContext('2d'), k = cv.width / BW;
    var t = TASARIM[d.tasarim] || TASARIM['sari-lacivert-cubuklu'];
    ctx.save();
    formaCiz(ctx, k, t);
    var ad = buyuk(d.ad).trim() || (d.ornek ? AD.ornek : '');
    var numara = String(d.numara || '').trim() || (d.ornek ? NUMARA.ornek : '');
    if (ad) metinCiz(ctx, ad, AD, k, t.yazi);
    if (numara) metinCiz(ctx, numara, NUMARA, k, t.yazi);
    // Kumaş: kıvrım gölgesi (multiply) + sırt ışığı (screen), yazılar dahil her şeye
    if (d.golge) { ctx.globalCompositeOperation = 'multiply'; ctx.drawImage(d.golge, 0, 0, cv.width, cv.height); }
    if (d.isik) { ctx.globalCompositeOperation = 'screen'; ctx.drawImage(d.isik, 0, 0, cv.width, cv.height); }
    ctx.restore();
  }

  /* ---------- Stüdyo ---------- */
  function Studyo(kok) {
    var ayarEl = kok.querySelector('[data-fso-forma-ayar]');
    var ayar = {};
    try { ayar = JSON.parse(ayarEl ? ayarEl.textContent : '{}'); } catch (e) { console.warn('[forma] ayar okunamadı', e); }
    this.kok = kok;
    this.ayar = ayar;
    this.api = String(ayar.api || '').replace(/\/+$/, '');
    this.m = Object.assign({}, METIN, ayar.metinler || {});
    this.form = ayar.form ? document.querySelector(ayar.form) : kok.closest('form');
    this.medya = ayar.medya ? document.querySelector(ayar.medya) : null;
    this.tasarim = TASARIM[ayar.tasarim] ? ayar.tasarim : 'sari-lacivert-cubuklu';
    this.gorsel = {};
    this.kur();
  }

  Studyo.prototype.kur = function () {
    var s = this, m = this.m;
    var kart = el('div', 'fso-mp fso-fm');
    var digerleri = (this.ayar.digerleri || []).filter(function (x) { return x && x.url; });
    kart.innerHTML =
      '<div class="fso-fm-alanlar">' +
        '<label class="fso-mp-alan fso-fm-ad"><span data-fm-et="adEt"></span><input type="text" maxlength="16" autocomplete="off" autocapitalize="characters" spellcheck="false" data-fm-ad></label>' +
        '<label class="fso-mp-alan fso-fm-numara"><span data-fm-et="numaraEt"></span><input type="text" inputmode="numeric" pattern="[0-9]*" maxlength="4" autocomplete="off" data-fm-numara></label>' +
      '</div>' +
      '<p class="fso-mp-yardim" data-fm-et="yardim"></p>' +
      (digerleri.length > 1 ?
        '<div class="fso-fm-diger"><p class="fso-mp-secim-baslik" data-fm-et="digerleri"></p><div class="fso-fm-diger-liste">' +
          digerleri.map(function (x) {
            return '<a class="fso-fm-renk' + (x.secili ? ' is-secili' : '') + '" href="' + x.url + '"' + (x.secili ? ' aria-current="page"' : '') + '>' +
              (x.gorsel ? '<img src="' + x.gorsel + '" alt="" width="56" height="78" loading="lazy">' : '') + '<span></span></a>';
          }).join('') + '</div></div>' : '') +
      '<div class="fso-mp-slot" data-fm-slot></div>' +
      '<button type="button" class="fso-mp-yukari" data-fm-yukari hidden>' + SIMGE.yukari + '<span data-fm-et="yukari"></span></button>' +
      '<p class="fso-mp-mesaj" data-fm-mesaj role="status" aria-live="polite"></p>';
    this.kok.appendChild(kart);
    this.kart = kart;
    this.$ = function (q) { return kart.querySelector(q); };
    this.$$ = function (q) { return kart.querySelectorAll(q); };
    this.$$('[data-fm-et]').forEach(function (e) { e.textContent = m[e.getAttribute('data-fm-et')] || ''; });
    this.$('[data-fm-ad]').placeholder = m.adOrnek;
    this.$('[data-fm-numara]').placeholder = m.numaraOrnek;
    // Diğer renklerin adları (metin olarak; HTML kaçışı gerektirmesin)
    var linkler = this.$$('.fso-fm-renk');
    digerleri.forEach(function (x, i) {
      var ad = (TASARIM[x.tasarim] && TASARIM[x.tasarim].ad) || x.ad || '';
      if (linkler[i]) { linkler[i].querySelector('span').textContent = ad; linkler[i].setAttribute('title', x.ad || ad); }
    });

    // Sahne: çerçeveli poster önizlemesi (ürün görsellerinin yerinde)
    var sahne = el('div', 'fso-mp-sahne fso-fm-sahne');
    sahne.innerHTML = '<div class="fso-mp-duvar"><div class="fso-mp-cerceve" data-fm-cerceve><canvas class="fso-mp-tuval" data-fm-tuval width="720" height="1008" role="img" aria-label="Poster önizlemesi"></canvas></div></div>';
    this.sahne = sahne;
    this.tuval = sahne.querySelector('[data-fm-tuval]');
    var gorunumKutu = el('div', 'fso-mp-gorunum');
    gorunumKutu.setAttribute('role', 'group');
    gorunumKutu.setAttribute('aria-label', m.gorunum);
    gorunumKutu.innerHTML = '<button type="button" data-fm-gorunum="poster" aria-pressed="true"></button><button type="button" data-fm-gorunum="galeri" aria-pressed="false"></button>';
    gorunumKutu.querySelector('[data-fm-gorunum="poster"]').textContent = m.gorunumPoster;
    gorunumKutu.querySelector('[data-fm-gorunum="galeri"]').textContent = m.gorunumGaleri;
    gorunumKutu.querySelectorAll('[data-fm-gorunum]').forEach(function (b) { b.addEventListener('click', function () { s.gorunumSec(b.getAttribute('data-fm-gorunum')); }); });
    this.gorunumKutu = gorunumKutu;
    this.gorunum = 'poster';
    this.yerlestir();

    // Olaylar: yazdıkça önizleme (numara yalnız rakam)
    var ad = this.$('[data-fm-ad]'), numara = this.$('[data-fm-numara]');
    var degisti = function () { s.gonderilen = null; s.ciz(); s.baskiOnYukle(); };
    ad.addEventListener('input', degisti);
    numara.addEventListener('input', function () {
      var v = numara.value.replace(/\D+/g, '').slice(0, 4);
      if (v !== numara.value) numara.value = v;
      degisti();
    });
    [ad, numara].forEach(function (g) { g.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); g.blur(); } }); });
    this.$('[data-fm-yukari]').addEventListener('click', function () { s.gorunumSec('poster'); s.sahne.scrollIntoView({ behavior: 'smooth', block: 'center' }); });

    // Çerçeve rengi (ürünün renk seçimi önizlemedeki çerçeveyi değiştirir)
    this.renkGuncelle();
    document.addEventListener('click', function (e) {
      if (s.ayar.renk && e.target.closest && e.target.closest(s.ayar.renk.replace(/\.selected\b/, ''))) requestAnimationFrame(function () { s.renkGuncelle(); });
    });

    // Sipariş özellikleri + sepete ekleme kapısı
    if (this.form) {
      this.girdiler = {};
      ['_tasarim', '_tasarim_pdf', '_tasarim_onizleme', '_isim', '_numara'].forEach(function (a) {
        var g = s.form.querySelector('input[name="properties[' + a + ']"]');
        if (!g) { g = document.createElement('input'); g.type = 'hidden'; g.name = 'properties[' + a + ']'; s.form.appendChild(g); }
        g.value = '';
        s.girdiler[a] = g;
      });
      window.addEventListener('click', function (e) {
        var b = e.target && e.target.closest && e.target.closest('button[type="submit"], input[type="submit"]');
        if (b && b.form === s.form) s.gonderiliyor(e, b);
      }, true);
      window.addEventListener('submit', function (e) { if (e.target === s.form && !s.gecis) s.gonderiliyor(e, null); }, true);
    }

    // Önizleme görselleri (tema) + yazı tipi
    var g = this.ayar.gorseller || {};
    Promise.all([
      g.golge ? resimYukle(g.golge).then(function (i) { s.gorsel.golge = i; }).catch(function () {}) : null,
      g.isik ? resimYukle(g.isik).then(function (i) { s.gorsel.isik = i; }).catch(function () {}) : null,
      yaziYukle(),
    ]).catch(function (e) { console.warn('[forma]', e); }).then(function () { s.ciz(); });
    this.ciz();
  };

  // Baskı boyu kumaş haritaları (R2, ~5 MB, bütün tasarımlarda aynı) müşteri yazmaya başlayınca arka planda indirilir
  Studyo.prototype.baskiOnYukle = function () {
    if (this.baskiGorsel) return this.baskiGorsel;
    var s = this, t = this.api + '/dosya/forma-zemin/kumas-';
    this.baskiGorsel = Promise.all([resimYukle(t + 'golge.jpg', true), resimYukle(t + 'isik.jpg', true)])
      .then(function (r) { return { golge: r[0], isik: r[1] }; })
      .catch(function (e) { s.baskiGorsel = null; throw e; });
    return this.baskiGorsel;
  };

  Studyo.prototype.yerlestir = function () {
    var medyada = !!this.medya;
    if (medyada) {
      if (this.medya.firstElementChild !== this.gorunumKutu) this.medya.insertBefore(this.gorunumKutu, this.medya.firstChild);
      if (this.gorunumKutu.nextElementSibling !== this.sahne) this.gorunumKutu.after(this.sahne);
    } else if (this.sahne.parentNode !== this.$('[data-fm-slot]')) {
      this.$('[data-fm-slot]').appendChild(this.sahne);
    }
    this.galeri = this.ayar.galeri ? document.querySelector(this.ayar.galeri) : null;
    this.gorunumKutu.hidden = !(medyada && this.galeri);
    this.$('[data-fm-yukari]').hidden = !medyada;
    this.gorunumSec(medyada ? this.gorunum : 'poster');
  };

  Studyo.prototype.gorunumSec = function (gorunum) {
    var medyada = !!this.medya && this.sahne.parentNode === this.medya;
    this.gorunum = medyada && this.galeri && gorunum === 'galeri' ? 'galeri' : 'poster';
    var galeride = this.gorunum === 'galeri';
    if (this.galeri) this.galeri.classList.toggle('fso-mp-gizle', medyada && !galeride);
    this.sahne.hidden = galeride;
    this.gorunumKutu.querySelectorAll('[data-fm-gorunum]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-fm-gorunum') === (galeride ? 'galeri' : 'poster')));
    });
  };

  Studyo.prototype.renkGuncelle = function () {
    var secili = this.ayar.renk ? document.querySelector(this.ayar.renk) : null;
    var deger = secili ? (secili.getAttribute('data-value') || secili.textContent || '') : '';
    var ad = 'siyah';
    for (var i = 0; i < RENKLER.length; i++) if (RENKLER[i][0].test(deger)) { ad = RENKLER[i][1]; break; }
    this.sahne.querySelector('[data-fm-cerceve]').setAttribute('data-renk', ad);
  };

  Studyo.prototype.durum = function () {
    return { tasarim: this.tasarim, ad: this.$('[data-fm-ad]').value.trim().replace(/\s+/g, ' '), numara: this.$('[data-fm-numara]').value.trim() };
  };

  Studyo.prototype.ciz = function () {
    var d = this.durum();
    posterCiz(this.tuval, { tasarim: d.tasarim, ad: d.ad, numara: d.numara, golge: this.gorsel.golge, isik: this.gorsel.isik, ornek: true });
  };

  Studyo.prototype.mesaj = function (t, tur) {
    var p = this.$('[data-fm-mesaj]');
    p.textContent = t || '';
    p.classList.toggle('is-error', tur === 'hata');
  };

  /* ---------- Sepete ekleme: baskı dosyası ---------- */
  Studyo.prototype.gonderiliyor = function (e, dugme) {
    if (this.gecis) return;
    var durdur = function () { e.preventDefault(); e.stopImmediatePropagation(); };
    if (this.gonderiyor) { durdur(); return; }
    var d = this.durum();
    if (!d.ad || !d.numara) {
      durdur();
      this.mesaj(this.m.once, 'hata');
      this.goster();
      (d.ad ? this.$('[data-fm-numara]') : this.$('[data-fm-ad]')).focus({ preventScroll: true });
      return;
    }
    var anahtar = JSON.stringify(d);
    if (this.gonderilen === anahtar && this.girdiler._tasarim_pdf.value) return; // aynı tasarım zaten hazır
    durdur();
    this.baskiGonder(anahtar, d, dugme || this.form.querySelector('button[type="submit"]'));
  };

  Studyo.prototype.gonder = function (fd, ilerleme) {
    var s = this;
    return new Promise(function (tamam, red) {
      var x = new XMLHttpRequest();
      x.open('POST', s.api + '/forma/baski');
      x.responseType = 'json';
      x.upload.onprogress = function (e) { if (e.lengthComputable) ilerleme(e.loaded / e.total); };
      x.onload = function () {
        var v = x.response || {};
        if (x.status >= 200 && x.status < 300 && v.pdf) tamam(v);
        else { var h = new Error(v.hata || s.m.baskiHata); h.sunucu = !!v.hata; red(h); }
      };
      x.onerror = function () { red(new Error(s.m.baskiHata)); };
      x.send(fd);
    });
  };

  Studyo.prototype.baskiGonder = async function (anahtar, d, dugme) {
    var s = this;
    this.gonderiyor = true;
    this.mesaj(this.m.baskiHazirlaniyor);
    if (dugme) { dugme.disabled = true; dugme.setAttribute('aria-busy', 'true'); }
    try {
      await yaziYukle();
      var bg = await this.baskiOnYukle();
      // 1) Poster tam çözünürlükte (50×70 cm @200 dpi); tuval açılamazsa küçült
      var baski = null;
      for (var i = 0; i < BASKI.length && !baski; i++) {
        var c = tuval(BASKI[i][0], BASKI[i][1]);
        try {
          posterCiz(c, { tasarim: d.tasarim, ad: d.ad, numara: d.numara, golge: bg.golge, isik: bg.isik, ornek: false });
          baski = await tuvalBlob(c, 0.92);
        } catch (e) { baski = null; }
        c.width = c.height = 1;
      }
      if (!baski) throw new Error('baskı oluşturulamadı');
      // 2) Sipariş satırı için küçük önizleme
      var k = tuval(600, 840);
      posterCiz(k, { tasarim: d.tasarim, ad: d.ad, numara: d.numara, golge: this.gorsel.golge || bg.golge, isik: this.gorsel.isik || bg.isik, ornek: false });
      var kucuk = await tuvalBlob(k, 0.86);
      var fd = new FormData();
      fd.append('baski', baski, 'baski.jpg');
      fd.append('onizleme', kucuk, 'onizleme.jpg');
      var r = await this.gonder(fd, function (oran) { s.mesaj(s.m.yukleniyor + ' %' + Math.round(oran * 100)); });
      var g = this.girdiler, ata = function (a, v) { if (g[a]) g[a].value = v || ''; };
      ata('_tasarim', 'Forma Poster — ' + (TASARIM[d.tasarim] ? TASARIM[d.tasarim].ad : d.tasarim));
      ata('_tasarim_pdf', r.pdf);
      ata('_tasarim_onizleme', r.onizleme);
      ata('_isim', buyuk(d.ad));
      ata('_numara', d.numara);
      this.gonderilen = anahtar;
      this.mesaj('');
      if (dugme) { dugme.disabled = false; dugme.removeAttribute('aria-busy'); }
      this.gecis = true;
      try { if (dugme) dugme.click(); else s.form.requestSubmit(); } finally { this.gecis = false; }
    } catch (e) {
      console.warn('[forma] baskı', e);
      this.mesaj(e && e.sunucu ? e.message : this.m.baskiHata, 'hata');
      if (dugme) { dugme.disabled = false; dugme.removeAttribute('aria-busy'); }
    } finally {
      this.gonderiyor = false;
    }
  };

  Studyo.prototype.goster = function () {
    var kart = this.kok.closest('[data-fso-custom]') || this.kok;
    var ofset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--fso-header-sticky-h'), 10) || 0;
    window.scrollTo({ top: Math.max(0, kart.getBoundingClientRect().top + window.scrollY - ofset - 12), behavior: 'smooth' });
    kart.classList.remove('is-need');
    void kart.offsetWidth;
    kart.classList.add('is-need');
  };

  function baslat() {
    document.querySelectorAll('[data-fso-forma]').forEach(function (k) {
      if (k.__fsoForma) return;
      k.__fsoForma = new Studyo(k);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', baslat);
  else baslat();
  window.FsoForma = { baslat: baslat, posterCiz: posterCiz, TASARIM: TASARIM, yaziYukle: yaziYukle };
})();
